<template>
  <div class="detail_content">
    <p class="title">| 基本信息</p>
    <el-row class="base_info">
      <el-col :span="3">
        <span>申请时间:</span>
      </el-col>
      <el-col :span="9">
        <p>{{detail.create_time}}</p>
      </el-col>
      <el-col :span="3">
        <span>提现类型:</span>
      </el-col>
      <el-col :span="9">
        <p v-if="detail.withdraw_type == 1">个人支付宝</p>
        <p v-if="detail.withdraw_type == 5">个人银行账户</p>
      </el-col>
    </el-row>
    <el-row class="base_info">
      <el-col :span="3">
        <span>提现账号:</span>
      </el-col>
      <el-col :span="9">
        <p>{{detail.withdraw_account}}</p>
      </el-col>
      <el-col :span="3">
        <span>所属小店:</span>
      </el-col>
      <el-col :span="9">
        <p>{{shop_info.shop_name}}</p>
      </el-col>
    </el-row>

    <el-row class="base_info">
      <el-col :span="3">
        <span>申请人账号:</span>
      </el-col>
      <el-col :span="9">
        <p>{{user_info.username}}</p>
      </el-col>
    </el-row>

    <p class="title">| 提现信息</p>
    <div class="order_info">
      <el-table
        :data="tableData"
        style="width:100%"
        max-height="600"
        :cell-style="tc"
        :header-cell-style="tccolor"
      >
        <el-table-column label="UID" prop="id"></el-table-column>
        <el-table-column label="提现金额" prop="money"></el-table-column>
        <el-table-column label="代扣税率" >
          <template slot-scope="scope">
            {{scope.row.rate}}%
          </template>
        </el-table-column>
        <el-table-column label="到账金额" prop="true_money"></el-table-column>
      </el-table>
    </div>

    <p class="title">| 审核设置</p>

    <el-row class="edit_setting" v-if='isSelect==true'>
      <el-col :span="8">
        <el-radio disabled v-model="status" label="1">
          <i>审核通过，允许提现</i>
        </el-radio>
      </el-col>
      <el-col :span="4">
        <el-radio  disabled v-model="status" label="2">
          <i>审核驳回</i>
        </el-radio>
      </el-col>
      <el-col :span="8">
        <el-input  size="mini" disbled v-model="reason" placeholder="请输入驳回理由"></el-input>
      </el-col>
    </el-row>


     <el-row class="edit_setting" v-else>
      <el-col :span="8">
        <el-radio  v-model="status" label="1">
          <i>审核通过，允许提现</i>
        </el-radio>
      </el-col>
      <el-col :span="4">
        <el-radio   v-model="status" label="2">
          <i>审核驳回</i>
        </el-radio>
      </el-col>
      <el-col :span="8">
        <el-input  size="mini" v-model="reason" placeholder="请输入驳回理由"></el-input>
      </el-col>
    </el-row>

    <div class="class_btn" v-if="isSelect==false">
      <el-button size="mini" type="primary"  @click="CertainWithdrawCancel">确定</el-button>
      <el-button size="mini" type="danager" @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { withDrawalDetail, withDrawRefuse, withDrawPass } from "@/api/finance";
export default {
  name: "discount_detail",
  props: ["visible", "currentId"],
  data() {
    return {
      status: "",
      reason: "",
      detail: {},
      shop_info: {},
      user_info: {},
      tableData: [],

      isSelect:true,   
      
      //提现
      isClickPassBtn:true

    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        // this.getRecordDetail()
        (this.tableData = []), this.getDiscountDetail();
      }
    }
  },
  methods: {
    tc() {
      return "text-align:center; color:#333333; font-size:12px;";
    },
    tccolor() {
      return "text-align:center;background-color:#f5f5f5; font-size:14px;";
    },
    handleCancel() {
      this.$emit("cancelShow");
    },
    CertainWithdrawCancel() {
      if (this.status === "1") {

        if(this.isClickPassBtn){
          this.getWithDrawpass();
        }

      } else if (this.status === "2") {
        this.getWithDrawRefuseData();
      }
    },

    //提现通过
    async getWithDrawpass() {
      this.isClickPassBtn = false
      let res = await withDrawPass({ id: this.currentId });
      if (res.code === 10000) {
        this.$message.success("提现通过成功");

        this.handleCancel();
        setTimeout(() => {
          this.isClickPassBtn  = true
        }, 2000);
      } else {
        this.$message.error(res.message);
        setTimeout(() => {
          this.isClickPassBtn  = true
        }, 2000);
      }
    },

    //提现失败
    async getWithDrawRefuseData() {
      let res = await withDrawRefuse({
        id: this.currentId,
        reason: this.reason
      });
      if (res.code === 10000) {
        this.$message.success("提现审核驳回");
      this.handleCancel();
      } else {
        this.$message.error(res.message);
      }
    },
    async getDiscountDetail() {
      let res = await withDrawalDetail({ id: this.currentId });
      if (res.code === 10000) {
        this.detail = res.data;
        this.user_info = res.data.user_info;
        this.shop_info = res.data.shop_info;
        if(res.data.reason != 'null'){
           this.reason = res.data.reason;
        }else{
           this.reason = '';
        }
      
        this.status = res.data.status + "";
        if(this.status == '1' || this.status == '2'){
          this.isSelect = true
        }else{
          this.isSelect = false
        }
        this.tableData.push({
          id: res.data.uid,
          money: res.data.money_apply,
          true_money: res.data.true_money,
          rate:res.data.tax_rate
        });
      } else {
        this.$message.error(res.message);
      }
    }
  }
};
</script>


<style scoped lang="scss">
.detail_content {
  padding: 20px;
  .title {
    font-size: 16px;
  }
  i {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    font-style: normal;
  }
  .base_info {
    margin: 15px 20px 20px;
    span {
      font-size: 12px;
      color: #999999;
    }

    p {
      font-size: 13px;
      color: #333333;
    }
  }
  .order_info {
    margin: 16px 0 20px;
  }

  .class_btn {
    margin-top: 30px;
    text-align: center;
  }

  .edit_setting {
    margin-top: 10px;
  }
}
</style>

